import type { SVGProps } from "react";
const SvgTravellersActive = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    {...props}
  >
    <path
      fill="currentColor"
      d="M15.419 18.34a.75.75 0 0 1-.628 1.16H.959a.751.751 0 0 1-.628-1.16 9 9 0 0 1 4.427-3.535 5.625 5.625 0 1 1 6.234 0 9 9 0 0 1 4.427 3.535m8.241-.014a9 9 0 0 0-4.418-3.521 5.625 5.625 0 0 0-5.677-9.687.374.374 0 0 0-.124.562 7.11 7.11 0 0 1 .34 8.432.375.375 0 0 0 .1.519 10.5 10.5 0 0 1 2.799 2.89c.298.456.42 1.005.342 1.544a.375.375 0 0 0 .37.435h5.654a.75.75 0 0 0 .724-.556.77.77 0 0 0-.11-.618"
    />
  </svg>
);
export default SvgTravellersActive;
